"use strict";

exports.__esModule = true;
exports.getAggregatedMeasuresData = void 0;
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _sortEventsByWorkdayStart = require("../common/utils/sortEventsByWorkdayStart");
var _formatToPlantTime = require("../common/utils/formatToPlantTime");
var getAggregatedMeasuresData = exports.getAggregatedMeasuresData = function getAggregatedMeasuresData(data, _ref) {
  if (data === void 0) {
    data = [];
  }
  var windowType = _ref.windowType,
    time = _ref.time;
  if (windowType === _timeAggregationBinMapping.HOUR_PER_DAY) {
    var timeBinName = (0, _timeAggregationBinMapping.getTimeGroupingBinName)(windowType);
    return (0, _formatToPlantTime.formatToPlantTime)({
      data: data,
      timezone: time.timezone,
      binName: timeBinName
    });
  } else if (windowType === _timeAggregationBinMapping.HOUR_OF_DAY) {
    return (0, _sortEventsByWorkdayStart.sortEventsByWorkdayStart)(data, time.timezone.name, time.currentWorkday.interval.startMillis, "by_hour");
  }
  return data;
};